<template>
  <div>
    <div
      style="margin-bottom: 0"
      class="columns is-gapless is-mobile has-background-white is-minH50p is-border">
      <div class="column is-padding-left is-padding-right is-self-centered">
        <span
          style="font-weight: 400"
          class="is-uppercase title is-6">Financement</span>
      </div>
    </div>
    <div class="columns is-gapless is-marginless-bottom">
      <div
        class="column is-narrow is-flex is-padding-small"
        :class="validFinancementPreResa ? 'has-background-success' : 'has-background-white--darken1 tooltip is-tooltip-right'"
        :data-tooltip="'Financement incomplet'">
        <span
          class="icon has-text-white is-self-centered"
          :class="validFinancementPreResa ? 'has-text-white' : 'has-text-danger'">
          <i
            :class="validFinancementPreResa ? 'fa-check-circle' : 'fa-exclamation-circle'"
            class="fas"></i>
        </span>
      </div>
      <div class="column has-background-white is-border-left is-border-right is-border-bottom">
        <div
          class="columns is-12 is-gapless is-marginless is-padding-left-small is-padding-right-small is-vcentered is-minH50p"
          :class="!notUsingLoan ? 'has-background-light is-border-bottom ' : 'has-background-dark'">
          <div class="column is-narrow">
            <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
              <div>
                <input
                  :disabled="isPending"
                  id="use_loan"
                  v-model="notUsingLoan"
                  name="use_loan"
                  class="switch is-success is-rounded"
                  type="checkbox">
                <label
                  for="use_loan"
                  style="font-size: 12.5px"
                  :class="!notUsingLoan ? '' : 'has-text-white'"
                  class="is-uppercase">Le réservataire déclare ne pas recourir à un ou plusieurs prêt
                  bancaire</label>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!notUsingLoan"
          style="flex-flow: row nowrap; gap: 20px"
          class="is-padding-small is-flex">
          <!-- Garanti prêt -->
          <div class="is-column is-gapless is-space-between is-marginless is-centered">
            <div
              class="control is-narrow is-paddingless is-nowrap">
              <input
                class="switch is-success is-rounded"
                id="use_caution"
                type="checkbox"
                name="use_caution"
                @input="$store.commit('modifyCurrentReservation', { key: 'funding_data.use_caution', value: reservation.funding_data.use_caution })"
                v-model="reservation.funding_data.use_caution">
              <label
                for="use_caution"
                class="is-uppercase">
                <span
                  class="is-size-6 is-margin-top-xxsmall">Garanti par une caution</span>
              </label>
            </div>
          </div>
          <div class="is-column is-gapless is-space-between is-marginless is-centered">
            <div
              class="control column is-narrow is-paddingless is-nowrap">
              <input
                class="switch is-success is-rounded"
                id="use_hypotheque"
                type="checkbox"
                name="use_hypotheque"
                @input="$store.commit('modifyCurrentReservation', { key: 'funding_data.use_hypotheque', value: reservation.funding_data.use_hypotheque })"
                v-model="reservation.funding_data.use_hypotheque">
              <label
                for="use_hypotheque"
                class="is-uppercase">
                <span
                  class="is-size-6 is-margin-top-xxsmall">Garanti par une hypothèque</span>
              </label>
            </div>
          </div>
        </div>
        <div
          v-if="!isPending && !notUsingLoan"
          class="is-padding-left is-padding-right is-padding-bottom">
          <div class="columns is-multiline">
            <div class="column is-12 is-6-fullhd">
              <r-label
                :label="'Nom de l\'organisme bancaire'"
                :is-required="false"
                :value="reservation.funding_data.initial_bank_name"></r-label>
              <v-input
                id="initial_bank_name"
                name="initial_bank_name"
                @input="val => $store.commit('modifyCurrentReservation', { key: 'funding_data.initial_bank_name', value: val })"
                :model="reservation.funding_data.initial_bank_name"
                data-vv-as="Organisme bancaire"
                v-validate="'min:2'"
                :errors-bag="errors"
                data-vv-value-path="val">
              </v-input>
            </div>
          </div>
          <div class="columns is-multiline">
            <div class="column is-4">
              <r-label
                :label="'MONTANT MAXIMUM À EMPRUNTER'"
                :value="reservation.funding_data.initial_loan_value"
                :red-check="true"></r-label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fas fa-euro-sign"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <v-input
                    id="initial_loan_value"
                    name="initial_loan_value"
                    @input="val => $store.commit('modifyCurrentReservation', { key: 'funding_data.initial_loan_value', value: val })"
                    :model="reservation.funding_data.initial_loan_value"
                    class=""
                    v-validate="'decimal:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    :number="true"
                    :three-space="true"
                    input-type="number"
                    data-vv-as="Montant maximum à emprunter">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <r-label
                :label="'MONTANT DE L\'APPORT'"
                :value="reservation.funding_data.contribution_amount"
                :red-check="true"></r-label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fas fa-euro-sign"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <v-input
                    id="contribution_amount"
                    name="contribution_amount"
                    @input="val => $store.commit('modifyCurrentReservation', { key: 'funding_data.contribution_amount', value: val })"
                    :model="reservation.funding_data.contribution_amount"
                    class=""
                    v-validate="'decimal:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    :number="true"
                    :three-space="true"
                    input-type="number"
                    data-vv-as="Montant de l'apport">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <r-label
                :label="'ORIGINE DE L\'APPORT'"
                :value="reservation.funding_data.origin_contribution"
                :red-check="true"></r-label>
              <v-input
                id="origin_contribution"
                name="origin_contribution"
                @input="val => $store.commit('modifyCurrentReservation', { key: 'funding_data.origin_contribution', value: val })"
                :model="reservation.funding_data.origin_contribution"
                data-vv-as="Origine de l'apport"
                v-validate="'min:2'"
                :errors-bag="errors"
                data-vv-value-path="val">
              </v-input>
            </div>
            <div class="column is-4">
              <r-label
                :label="'DURÉE max du prêt'"
                :value="reservation.funding_data.initial_loan_duration"
                :red-check="true"></r-label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="far fa-clock"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <v-input
                    id="initial_loan_duration"
                    name="initial_loan_duration"
                    @input="val => $store.commit('modifyCurrentReservation', { key: 'funding_data.initial_loan_duration', value: val })"
                    :model="reservation.funding_data.initial_loan_duration"
                    :placeholder="'en année'"
                    data-vv-as="Durée max du prêt"
                    v-validate="'min:1'"
                    :errors-bag="errors"
                    data-vv-value-path="val">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <r-label
                :label="`taux d’interêt max`"
                :red-check="true"
                :value="reservation.funding_data.initial_loan_rate"></r-label>
              <div class="field has-addons is-marginless-bottom">
                <div class="control">
                  <a class="button is-square is-static is-border"><span class="icon"><i
                    class="fas fa-percent"></i></span></a>
                </div>
                <div class="control is-expanded">
                  <input
                    name="taux_com"
                    v-model.number="reservation.funding_data.initial_loan_rate"
                    max="100"
                    @input="$store.commit('modifyCurrentReservation', { key: 'funding_data.initial_loan_rate', value: reservation.funding_data.initial_loan_rate })"
                    class="input"
                    :step="0.1"
                    type="number"
                    data-type-cy="input"
                    data-value-cy="initial_loan_rate">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        class="is-padding-left-small is-padding-right-small is-flex is-minH50p is-border-bottom is-border-left is-border-right"
        :class="!reservation.funding_data.security_deposit ? 'has-background-light ' : ' has-background-dark'">
        <div class="is-self-centered is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right">
          <div>
            <input
              id="security_deposit"
              v-model="reservation.funding_data.security_deposit"
              name="security_deposit"
              class="switch is-success is-rounded"
              type="checkbox">
            <label
              for="security_deposit"
              :class="!reservation.funding_data.security_deposit ? '' : 'has-text-white'"
              class="is-uppercase">Dépot de garantie déposé à la signature</label>
          </div>
        </div>
      </div>
      <div
        v-if="reservation.funding_data.security_deposit"
        class="notification is-border-bottom is-border-left is-border-right has-background-light is-multiline columns is-gapless is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-vcentered is-minH50p is-marginless-bottom">
        <div class="column is-12 is-padding-bottom-small is-padding-left-xsmall">
          <div class="">
            <span class="is-uppercase is-size-7 has-text-weight-medium">Merci de préciser le montant du dépot de garantie déposé à la signature du contrat de réservation.</span>
          </div>
        </div>
        <div class="column is-narrow is-4 is-padding-left-xsmall">
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square">
                <span class="icon"><i class="fas fa-euro-sign"></i></span>
              </a>
            </div>
            <div class="control is-expanded">
              <v-input
                id="security_deposit_value"
                name="Dépot de garantie"
                @input="val => $emit('update:setPercentageContribution', val)"
                :model="reservation.funding_data.security_deposit_value"
                class=""
                v-validate="'decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                :number="true"
                :three-space="true"
                input-type="number"
                data-vv-as="">
              </v-input>
            </div>
          </div>
        </div>
        <div class="column is-narrow is-4 is-padding-left-large">
          <div class="field has-addons">
            <div class="control is-expanded">
              <v-input
                id="percentage_contribution"
                name="Pourcentage de contribution"
                @input="val => $emit('update:setSecurityDepositValue', val)"
                :model="reservation.funding_data.percentage_contribution"
                class=""
                v-validate="'decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                :number="true"
                input-type="number"
                data-vv-as="">
              </v-input>
            </div>
            <div class="control">
              <a class="button is-static is-border is-square">
                <i class="fas fa-percentage"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="column is-narrow is-4 is-padding-left-large">
          <div class="select is-fullwidth">
            <select
              v-model="reservation.funding_data.security_deposit_type">
              <option
                :value="null"
                disabled
                selected>
                Selectionnez
              </option>
              <option
                v-for="s in securityDepositeTypeList"
                :value="s.value"
                :key="s.value">
                {{ s.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DefaultValues } from '@/mixins'

export default {
  name: 'FinancementPreResa',
  mixins: [DefaultValues],
  props: {
    reservation: {
      type: Object,
      required: true
    },
    not_using_loan: {
      validator (value) {
        return typeof value === 'boolean'
      },
      required: true
    }
  },
  data () {
    return {
      notUsingLoan: this.not_using_loan
    }
  },
  computed: {
    isPending () {
      return this.reservation.status === 'pending'
    },
    validFinancementPreResa () {
      if (this.notUsingLoan) {
        return true
      } else {
        if (this.reservation.funding_data.initial_loan_value && (this.reservation.funding_data.contribution_amount === 0 || this.reservation.funding_data.contribution_amount) && this.reservation.funding_data.origin_contribution && this.reservation.funding_data.initial_loan_duration && this.reservation.funding_data.initial_loan_rate) {
          return true
        } else {
          return false
        }
      }
    }
  },
  watch: {
    // Changement de la prop
    not_using_loan (newValue) {
      this.notUsingLoan = newValue
    },
    notUsingLoan (newValue) {
      this.$emit('update:notUsingLoan', newValue)
    }
  }
}
</script>
